<script setup>
import { defineEmits } from 'vue'
const emit = defineEmits(['del', 'open'])

const openList = () => {
  emit('open')
}

const delList = () => {
  emit('del')
}
</script> 

<template>
  <div class="tool-model">
    <div class="tool-model-container">
      <slot>
        <div class="model-icon icon-magnify" @click="openList">
          <i class="iconfont icon-fangda6"></i>
        </div>
        <div class="model-icon icon-del" @click="delList">
          <i class="iconfont icon-shanchu6"></i>
        </div>
      </slot>
    </div>
  </div>
</template>

<style scoped lang='scss'>
.tool-model {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  overflow: hidden;
  &-container {
    background-color: #0000007d;
    width: 100%;
    height: 100%;
    position: absolute;
    right: -100%;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    .model-icon {
      width: 32px;
      height: 32px;
      border-radius: 25px;
      background-color: rgba(164, 158, 158, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        font-size: 24px;
        color: #fff;
        cursor: pointer;
      }
    }

    .icon-magnify {
      margin-right: 10px;

      &:hover {
        background-color: #26A3F6;
      }
    }

    .icon-del {
      &:hover {
        background-color: #EF4446;
      }
    }
  }
  &:hover {
    .tool-model-container {
      right: 0;
    }
  }
}
</style>
